import { Control } from "react-hook-form";
import { makeStyles } from "tss-react/mui";
import {
  MiControlledDatePicker,
  MiFileUpload,
  MiSection,
} from "@miplatform/components";
import { validInspectionFileTypes } from "@miplatform/constants";
import { IUploadedFile } from "@miplatform/types";
import { mdiCalendarOutline, mdiPlus, mdiTag } from "@mdi/js";
import { Box } from "@mui/system";
import { InspectionSectionHeader } from "../InspectionSectionHeader";
import { IInspectionForm } from "../inspectionFormSchemas";

export const GreenTagDrawer = ({
  control,
  onFileUploadChange,
}: {
  control: Control<IInspectionForm>;
  onFileUploadChange: (fileList: IUploadedFile[]) => void;
}) => {
  const { theme, classes } = useStyles();

  return (
    <Box>
      <MiSection
        headerTitle="Green Tag Inspection"
        headerIcon={mdiTag}
        headerIconColor={theme.palette.success.main}
      >
        <Box className={classes.formContainer}>
          <InspectionSectionHeader
            title="Inspection Date/Time"
            icon={mdiCalendarOutline}
          />
          <Box className={classes.dateTimeInputContainer}>
            <Box className={classes.inputContainer}>
              <MiControlledDatePicker
                label="Inspected Date"
                name="inspectedDate"
                control={control}
                required
                whiteBackground
              />
            </Box>
            <Box className={classes.inputContainer}>
              <MiControlledDatePicker
                label="Reported Date"
                name="reportedDate"
                control={control}
                required
                whiteBackground
              />
            </Box>
          </Box>
          <Box>
            <MiFileUpload
              dragAndDrop
              showUploadButton
              buttonStartIcon={{ path: mdiPlus }}
              title="Upload Files"
              validFileTypes={validInspectionFileTypes}
              onChange={onFileUploadChange}
              acceptFiles={validInspectionFileTypes.join(",")}
            />
          </Box>
          {/* TODO: Uncomment when notes are ready
          <Box alignItems="center" display="flex" flexDirection="column">
            {notesAdded ? (
              <Box className={classes.inputContainer}>
                <MiControlledTextField
                  label="Notes"
                  name="notes"
                  formControl={control}
                />
              </Box>
            ) : (
              <MiButton
                className={classes.addNotesButton}
                variant={BUTTON_VARIANTS.TEXT}
                onClick={() => setNotesAdded(true)}
              >
                Add Notes
              </MiButton>
            )}
          </Box> */}
        </Box>
      </MiSection>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  section: {
    padding: theme.spacing(2),
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  },
  dateTimeInputContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  inputContainer: {
    flex: 1,
  },
  addNotesButton: {
    textDecoration: "underline",
    textUnderlineOffset: theme.spacing(1.5),
  },
}));
